export const AVAIL_LABELS = {
  disponibile: "Disponibile", limitata: "Disponibilità limitata", da_ordinare: "Da ordinare",
  temporaneamente_non_disponibile: "Temporaneamente non disponibile", esaurito: "Esaurito", su_richiesta: "Su richiesta",
};
export const AVAIL_COLORS = {
  disponibile: "text-emerald-700 border-emerald-700/40", limitata: "text-amber-700 border-amber-700/40",
  da_ordinare: "text-amber-700 border-amber-700/40", temporaneamente_non_disponibile: "text-red-700 border-red-700/40",
  esaurito: "text-red-700 border-red-700/40", su_richiesta: "text-gold border-gold/40",
};
export const availOf = (p) => p.availability || "disponibile";
export const isPurchasable = (p) =>
  !["esaurito", "temporaneamente_non_disponibile", "su_richiesta"].includes(availOf(p))
  && p.purchasable !== false && !p.price_on_request;
